
import {Vue, Component} from 'vue-property-decorator';

/**
 * OfisPro kullanım süresi dolduğunda (grace dönemi) Büro modülü sayfalarının
 * üstünde gösterilen kalıcı uyarı banner'ı. Süre dolu değilse hiçbir şey render etmez.
 */
@Component({})
export default class KullanimSuresiUyari extends Vue {

}
